import React from "react";
import { styles } from "./styles";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Close } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";

interface Props {
  title: string;
  children: React.ReactNode;
  visible: boolean;
  onClose: Function;
  footer?: React.ReactNode;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  maxWidth?: number | string;
}

const CustomModal = (props: Props) => {
  const {
    title,
    children,
    visible,
    onClose,
    footer,
    onSubmit,
    maxWidth,
  } = props;

  const handleClose = () => onClose();

  return (
    <Modal
      open={visible}
      onClose={handleClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          ...styles.modal,
          ...(maxWidth != null ? { maxWidth } : {}),
        }}
      >
        <Box
          {...(onSubmit
            ? {
                component: "form" as const,
                noValidate: true,
                onSubmit,
              }
            : { component: "div" as const })}
          sx={styles.modalBody}
        >
          <Box sx={styles.modalHeader}>
            <Typography
              id="custom-modal-title"
              variant="h3"
              component="h2"
              sx={styles.heading}
            >
              {title}
            </Typography>
            <IconButton
              aria-label="close"
              sx={styles.modalClose}
              onClick={handleClose}
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>
          <Box id="custom-modal-description" sx={styles.modalContent}>
            {children}
          </Box>
          {footer ? <Box sx={styles.modalFooter}>{footer}</Box> : null}
        </Box>
      </Box>
    </Modal>
  );
};

export default React.memo(CustomModal);
